import { useTranslation } from "react-i18next";
import TrademarkManagerContext from "../../context/trademark-manager/context";
import TrademarkManagerContextProvider from "../../context/trademark-manager/provider";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../context/app/context";
import { useNavigate } from "react-router-dom";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import PageHeader from "../../components/general/layout/page-header";
import ExportToExcelModal from "../../components/general/excel/export-to-excel-modal";
import TemplateExportExcel from "../../components/general/excel/expor-excel";
import { columnsExportTradeManagerExcel, IExportTradeManagerExcel } from "../../models/trademark-manager/request";
import TradeManagerTable from "../../components/trademark-manager/trademark-manager-table";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { Button, Divider } from "antd";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import { FileExcelOutlined, PlusOutlined } from "@ant-design/icons";
import SearchFilterCard from "../../components/general/filter-card";
import TrademarkFilter from "../../components/trademark/trademark-filter";
import TrademarkManagerFilter from "../../components/trademark-manager/trademark-manager-filter";

interface IProps {
  children?: React.ReactNode;
}

const TrademarkManager: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();

  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(TrademarkManagerContext);
  const [exportModalVisible, setExportModalVisible] = useState(false);

    useEffect(() => {
      actions.setSearch(search);
    }, [search]);
  
    const isMounted = useIsMount();
    useEffect(() => {
      !isMounted && actions.getData();
    }, [query, direction]);

  return(
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("charity_managers")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={CAN_VIEW_HOME_PAGE}>
            <Button
              type="primary"
              onClick={() => {
                setExportModalVisible(true);
              }}
              icon={<FileExcelOutlined />}
            >
              {t("export_to_excel")}
            </Button>
            <Divider key={1} type="vertical" />
            <Button
              type="primary"
              onClick={() => {
                navigate(`/charity_managers/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_user")}
            </Button>
          </Can>,
        ]}
      />
      <SearchFilterCard
        formId="trademark-manager-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      >
        <TrademarkManagerFilter />
      </SearchFilterCard>
       <ExportToExcelModal
        id="export-category"
        title={t("export_to_excel")}
        visible={exportModalVisible}
        toggleVisible={setExportModalVisible}
        width="50vw"
        defaultValues={
          {
            id: false,
            firstName: false,
            lastName: false,
            trademarkName: false,
            createdAt: false,
            mobile: false,
            status: false,
          } as IExportTradeManagerExcel
        }
        loading={loading.includes("create")}
        onSubmit={async (columnsNames) => {
          // await a(columnsNames);
          await actions.exportExcel({...columnsNames, is_special: false});
          setExportModalVisible(false);
        }}
      >
        <TemplateExportExcel names={columnsExportTradeManagerExcel} />
      </ExportToExcelModal>
      <TradeManagerTable/>
    </div>
  )
}




const TrademarkManagerPage = () => {
  return (
    // ContextProvider
    <TrademarkManagerContextProvider>
      <TrademarkManager/>
    </TrademarkManagerContextProvider>
  );
};
export default TrademarkManagerPage;
